import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { PrincipalModificationInput } from '../loan/Modification';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreatePrincipalModificationEvent = BaseLoanEvent.extend({
  type: z.literal('createPrincipalModification'),
  principalModification: PrincipalModificationInput,
  borrowerIds: z.array(BorrowerId),
});

export type CreatePrincipalModificationEvent = z.infer<typeof CreatePrincipalModificationEvent>;
